import { render } from "./NavItem.vue?vue&type=template&id=898550ee"
import script from "./NavItem.vue?vue&type=script&lang=js"
export * from "./NavItem.vue?vue&type=script&lang=js"
script.render = render

export default script